export const getBackUrl = () => {
    return window.location.origin + window.location.pathname
}

export const isNavigateToSdkFail = (error: unknown) => {
    return error && typeof error === 'object' && 'type' in error && error.type === 'NSP_PAY_SDK_FAIL'
}
